const DUPLICATION_ERRORS = {
	DUPLICATION_BORDEREAU: 'Veuillez choisir un bordereau.',
	DUPLICATION_BORDEREAU_LIBELLE:
		'Le libellé du nouveau bordereau doit être renseigné.',
	DUPLICATION_DATE_EMISSION:
		"La date d'émission du nouveau bordereau doit être renseignée.",
	DUPLICATION_DATE_PRELEVEMENT:
		'La date de prélèvement doit être renseignée si la coche est activée.',
	DUPLICATION_REALISATION_PRESTATION:
		'La date de réalisation de la prestation doit être renseignée si la coche est activée.',
	DUPLICATION_ECHEANCE:
		"La date d'échéance doit être renseignée si la coche est activée.",
	DUPLICATION_DEPART_DELAI_GLOBAL_PAIEMENT:
		'La date de départ du délai global de paiement doit être renseignée si la coche est activée.',
} as const;

export default DUPLICATION_ERRORS;
